import React from "react";
import "../styles/Tooltip.css";

const Tooltip = ({ text }) => {
  return (
    <div className="tooltip-container">
      <span className="help-circle">?</span>
      <span className="tooltip-text">{text}</span>
    </div>
  );
};

export default Tooltip;